export const getTelephonyProvidersUrl = () => 'agency/telephony_providers';
export const getTelephonyProviderUrl = (id: string | number) => `agency/telephony_providers/${id}`;
export const getTelephonyProviderBusinessesUrl = (id: string | number) => `agency/telephony_providers/${id}/businesses`;
export const manualSyncTelephonyProviderUrl = (id: string | number) => `agency/telephony_providers/${id}/manual_sync`;
export const getTelephonyProviderSyncLogsUrl = (id: string | number, businessId?: number) =>
  `agency/telephony_providers/${id}/synchronizer_logs?telephony_provider[business_id]=${businessId}`;
export const updateTelephonyProviderMappingUrl = (id: string | number) =>
  `agency/telephony_providers/${id}/update_mapping`;
